export default __webpack_public_path__ + "img/background.dd9cb123.jpg";